export type RdsCodeSortType = 'VALUE' | 'NAME' | 'NATURAL';
export type RdsCodeSortDirection = 'ASC' | 'DESC';

export class RdsTabulationSortOptions {
  constructor(
    public rowType: RdsCodeSortType = 'VALUE',
    public rowDirection: RdsCodeSortDirection = 'ASC',
    public colType: RdsCodeSortType = 'VALUE',
    public colDirection: RdsCodeSortDirection = 'ASC'
  ) {}
}
